import React from "react";
import { Link } from "react-router-dom";
export const Footer = () => {
  return <footer className="w-full bg-white border-t" data-id="element-30">
      <div className="max-w-4xl mx-auto px-4 py-6 flex justify-end" data-id="element-31">
        <div className="space-x-6" data-id="element-32">
          <Link to="/terms" className="text-sm text-gray-600 hover:text-emerald-700 transition-colors" data-id="element-33">
            Terms
          </Link>
          <Link to="/privacy" className="text-sm text-gray-600 hover:text-emerald-700 transition-colors" data-id="element-34">
            Privacy
          </Link>
        </div>
      </div>
    </footer>;
};